import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'

import Typography from '@material-ui/core/Typography'
import FormControl from '@material-ui/core/FormControl'
import Configure from './Configure'
const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative'
  },
  layout: {
    width: 'auto',
    marginTop: theme.spacing(5),

    [theme.breakpoints.up(1000 + theme.spacing(2) * 2)]: {
      width: 1000,
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },
  paper: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(1000 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3)
    }
  },
  stepper: {
    padding: theme.spacing(3, 0, 5)
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1)
  }
}))

function BestTeachingAwardImport(props) {
  const classes = useStyles()
  const { data } = props
  const [activeStep, setActiveStep] = React.useState(0)

  const handleNext = async () => {}

  const handleBack = () => {}

  return (
    <>
      <Typography
        style={{
          marginBottom: '16px'
        }}
        component='h1'
        variant='h5'
        align='center'
      >
        {' '}
        Best Teaching Award Report Data Configuration
      </Typography>
      <FormControl fullWidth>
        <Configure />
      </FormControl>
    </>
  )
}

function mapStateToProps(state) {
  return {
    data: state.BestTeachingAwardReport
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadBestTeachingAwardData: (payload) => {
    dispatch(loadBestTeachingAwardData(payload))
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BestTeachingAwardImport)
